import React, { type MouseEvent, type KeyboardEvent } from 'react';
import { styled } from '@compiled/react';
import CrossIcon from '@atlaskit/icon/core/cross';

import { token } from '@atlaskit/tokens';

type ClearButtonProps = {
	label: string;
	onClick: (e: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>) => void;
};

export const ClearButton = ({ label, onClick }: ClearButtonProps): React.JSX.Element => (
	<StyledClearButton
		// @ts-expect-error ts(2322) Type 'string' is not assignable to type 'number'.
		tabIndex="0"
		role="button"
		onClick={onClick}
		onKeyPress={onClick}
		data-testid="jql-editor-basic.common.ui.clear-button" // eslint-disable-line jira/integration/test-id-by-folder-structure
	>
		<CrossIcon color="currentColor" label={label} size="small" />
	</StyledClearButton>
);

export default ClearButton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledClearButton = styled.span({
	display: 'inline-flex',

	color: token('color.text.subtlest'),
	'&:hover': {
		color: token('color.text'),
	},
	'&:focus': {
		color: token('color.text'),
		/*
		 * Keyboard focus handling
		 * Note - use of box-shadow instead of outline is based on
		 * Atlaskit button implementation
		 */

		boxShadow: `0 0 0 2px ${token('color.border.focused')}`,
		outline: 'none',
		// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
		borderRadius: token('radius.small', '3px'),
	},
});
